/* Игровой мир: стиль приложения (карточки, чипсы, жёлтый акцент) с «игровыми» акцентами — плашки арта, полосы опыта. */
.world { min-height: 100%; }
/* Фон всех экранов мира — поле сцены, размытое и приглушённое: карточки читаются, а мир — один (слово владельца 10.10) */
.world { isolation: isolate; }
/* Планшет и компьютер (слово владельца 12.10): мир — колонка телефона по центру, фон — на весь экран. Без этого полосы
   валют и прочности тянулись на всю ширину окна (1248 px), а кнопки разъезжались по краям. Колонка — 460 px,
   умноженные на масштаб мира (worldZoom.ts): сцена внутри увеличена целиком. */
/* zoom увеличивает и собственную ширину блока: 460 px здесь — уже увеличенные */
.world { max-width: 460px; margin-inline: auto; zoom: var(--world-zoom, 1); }
.backdrop { position: fixed; inset: -24px; z-index: -2; width: calc(100% + 48px); height: calc(100% + 48px); object-fit: cover;
  filter: blur(14px) saturate(115%); pointer-events: none; }
.backdropTint { position: fixed; inset: 0; z-index: -1; pointer-events: none; background: color-mix(in srgb, var(--ground) 62%, transparent); }
:global(:root[data-scheme='dark']) .backdropTint { background: rgba(10, 14, 12, 0.7); }
/* шапка безопасной зоны = кусок того же фона: картинка и тень стоят там же, где фон (inset −24 от окна) — шва нет */
.cap { position: fixed; top: 0; left: 0; right: 0; z-index: 7; height: calc(var(--tg-safe-top) + var(--tg-content-safe-top) + 10px); overflow: hidden; pointer-events: none;
  -webkit-mask-image: linear-gradient(#000 calc(100% - 10px), transparent); mask-image: linear-gradient(#000 calc(100% - 10px), transparent); }
.cap > img { position: absolute; top: -24px; left: -24px; width: calc(100vw / var(--world-zoom, 1) + 48px); height: calc(100vh / var(--world-zoom, 1) + 48px); object-fit: cover;
  filter: blur(14px) saturate(115%); }
.cap > span { position: absolute; inset: 0; background: color-mix(in srgb, var(--ground) 62%, transparent); }
:global(:root[data-scheme='dark']) .cap > span { background: rgba(10, 14, 12, 0.7); }
/* сцена с полем — своя (поле до самого верха), полоса не нужна */
:global(:root[data-scene='field']) .cap, :global(:root[data-scene='map']) .cap { display: none; }
.tabTitle { margin: var(--space-4) var(--space-4) var(--space-1, 4px); font-size: var(--fs-title); font-weight: 800; }

.page { display: flex; flex-direction: column; gap: var(--space-4); padding: var(--space-3) var(--space-4) var(--space-5, 24px); }
.caption { font-size: var(--fs-caption); color: var(--content-secondary); }

/* Арт-заглушка: эмодзи на круглой плашке цвета --tone (worldArt.tsx) */
.art {
  flex: none; display: inline-flex; align-items: center; justify-content: center; border-radius: 30%; line-height: 1;
  background: radial-gradient(circle at 30% 25%, color-mix(in srgb, var(--tone) 55%, #fff), var(--tone));
  box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.12);
}

/* 3D-значок (Fluent Emoji 3D): без плашки, мягкая тень цвета ключа под ним */
.art3d { flex: none; display: inline-flex; align-items: center; justify-content: center; position: relative; }
.art3d img { width: 100%; height: 100%; object-fit: contain; filter: drop-shadow(0 3px 4px color-mix(in srgb, var(--tone) 45%, rgba(0, 0, 0, 0.25))); }
.glyph { display: inline-block; vertical-align: -0.2em; object-fit: contain; }
/* HQ-2072: значок не загрузился — пустое место его размера (строка не съезжает) */
.glyphGap { flex: none; }

/* Карточка игрока */
.hero {
  display: flex; align-items: center; gap: var(--space-4); padding: var(--space-4); border-radius: var(--radius-card);
  background: linear-gradient(135deg, color-mix(in srgb, var(--accent) 28%, var(--surface)), var(--surface) 70%);
}
.heroText { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px; }
.heroRole { font-size: 20px; font-weight: 700; overflow-wrap: normal; word-break: normal; hyphens: manual; }
.heroLevel { font-size: var(--fs-subheadline); font-weight: 600; color: var(--content-sub-primary); }
.track { flex: none; height: 8px; border-radius: 4px; background: var(--ground); overflow: hidden; margin-top: 4px; }
.fill { height: 100%; border-radius: 4px; background: var(--accent); transition: width 0.4s ease; }

.primary {
  width: 100%; min-height: 48px; margin-top: var(--space-3); display: flex; align-items: center; justify-content: center;
  gap: var(--space-3); border-radius: var(--radius-button); background: var(--accent); color: var(--on-accent);
  font-size: var(--fs-callout); font-weight: 700;
}
.primary .reward { color: rgba(33, 37, 41, 0.72); }
.primary:disabled, .small:disabled { opacity: 0.55; }

/* Строки (сундуки, задания) */
.list { display: flex; flex-direction: column; }
.row { display: flex; align-items: center; gap: var(--space-3); min-height: 64px; padding: var(--space-2) 0; }
.row + .row { border-top: 0.5px solid var(--content-border); }
.rowText { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; }
.rowTitle { font-size: var(--fs-subheadline); font-weight: 600; }
.small {
  flex: none; min-height: 36px; padding: 0 var(--space-4); border-radius: var(--radius-chip);
  background: var(--accent); color: var(--on-accent); font-size: var(--fs-subheadline); font-weight: 600;
}
.empty { display: flex; align-items: center; gap: var(--space-3); font-size: var(--fs-subheadline); color: var(--content-sub-primary); }
.empty .art { filter: grayscale(1); opacity: 0.6; }
.reward { display: inline-flex; flex-wrap: wrap; gap: var(--space-2); font-size: var(--fs-caption); font-weight: 600; color: var(--content-sub-primary); white-space: nowrap; }
.rewardLarge { font-size: 22px; color: var(--on-accent); gap: var(--space-3); }

/* Задания */
.taskGroup + .taskGroup { margin-top: var(--space-3); }
.groupTitle { margin-bottom: var(--space-1); font-size: var(--fs-footnote); font-weight: 600; color: var(--content-fine); text-transform: uppercase; letter-spacing: 0.2px; }
.task { display: flex; align-items: center; gap: var(--space-3); padding: var(--space-2) 0; }
.task + .task { border-top: 0.5px solid var(--content-border); }
.taskBar { display: flex; align-items: center; gap: var(--space-2); }
.taskBar .track { flex: 1; margin-top: 0; height: 6px; }
.taskClaimed .rowTitle { color: var(--content-secondary); }
.claimed { flex: none; font-size: var(--fs-caption); font-weight: 600; color: var(--positive); }

@media (prefers-reduced-motion: reduce) { .fill { transition: none; } }
.taskBar .caption { line-height: 1; }

/* бонус (сундук сезона) */
.bonus { font-size: var(--fs-callout); font-weight: 700; }


/* недоступная кнопка — серая, а не бледно-жёлтая: недоступное действие не должно выглядеть активным */
.small:disabled { background: var(--ground); color: var(--content-secondary); opacity: 1; }
.guildChips { padding: var(--space-2) var(--space-4) 0; }
/* Вкладки папки сцены и вкладки сверху «Рейтинга» / «Сообщества» (вариант B): стекло на поле, выбранная — акцент */
.topTabs { display: flex; gap: var(--space-2); overflow-x: auto; scrollbar-width: none; padding: var(--space-2) var(--space-4) var(--space-1, 4px); }
.topTabs::-webkit-scrollbar { display: none; }
.topTab {
  position: relative; flex: none; display: inline-flex; align-items: center; gap: 6px; min-height: 36px; padding: 0 var(--space-3);
  border-radius: var(--radius-chip); background: color-mix(in srgb, var(--surface) 82%, transparent);
  font-size: var(--fs-subheadline); font-weight: 600; color: var(--content-sub-primary);
}
/* У папки (значки) — все вкладки видны сразу: равные колонки, значок над подписью, точка — в углу */
/* вкладка ≥ 68 px и не уже своей подписи (HQ-1202); свободное место делится поровну; не влезли — лента прокручивается (как вкладки iOS на SE) */
.hubTabs { overflow-x: auto; overflow-y: visible; scrollbar-width: none; padding-top: 2px; }
.hubTabs::-webkit-scrollbar { display: none; }
.hubTabs .topTab {
  flex: 1 0 auto; min-width: 68px; flex-direction: column; justify-content: center; gap: 2px; min-height: 60px; padding: 6px 4px;
  border-radius: 14px; font-size: 12px; line-height: 14px;
}
/* HQ-1202: подпись вкладки целиком одной строкой — без многоточия и без разрыва слов (hi/bn/ta/te на 360 px, en «Achievements»):
   вкладка растёт по подписи, полоса прокручивается; высота полосы при любом языке — как у одной строки (66 px) */
.hubTabs .topTab > span:not([class]) { white-space: nowrap; }
/* HQ-1202 v3/v4: закрытая вкладка растёт по самой длинной своей строке — подписи (ta «நினைவுச்சின்னங்கள்») и строке замка сервера
   (te «లెవెల్ 15లో తెరుచుకుంటుంది»): обе одной строкой, целиком в кнопке, без разрыва слов и налезания на соседей;
   при en строка замка — одна строка вместо двух, полоса не выше базы */
.hubTabs .topTabLockBody { align-self: stretch; }
.hubTabs .topTabLockBody > span:not([class]), .hubTabs .topTabLockText { white-space: nowrap; }
.hubTabs .topTabDot, .hubTabs .topTabCount { position: absolute; top: 4px; right: 6px; }
/* HQ-954: закрытая вкладка папки — замок на значке, подпись сервера и полоска; приглушена */
.topTabLocked { opacity: 0.85; }
.topTabLockBody { display: flex; flex-direction: column; align-items: center; gap: 2px; min-width: 0; max-width: 100%; }
.topTabs:not(.hubTabs) .topTabLockBody { align-items: flex-start; }
.topTabLockText { font-size: 11px; line-height: 13px; font-weight: 700; color: var(--content-secondary); white-space: normal; text-align: center; }
/* HQ-1236: светлая тема — строка замка ≥ 4.5:1 к плашке вкладки и при чёрной сцене под ней (было ≈2.7:1: --content-secondary × 0.85).
   Приглушение снято с вкладки и стоит на значке, подписи и полоске — строка замка без прозрачности, токен --content-sub-primary
   (--content-fine без приглушения — 4.4:1 на чёрной сцене). Тёмная тема — как была (0.85 на вкладке, --content-secondary); страж tests/hubLockContrast1236 */
:global(:root:not([data-scheme='dark'])) .topTabLocked { opacity: 1; }
:global(:root:not([data-scheme='dark'])) .topTabLocked > :not(.topTabLockBody),
:global(:root:not([data-scheme='dark'])) .topTabLockBody > :not(.topTabLockText) { opacity: 0.85; }
:global(:root:not([data-scheme='dark'])) .topTabLockText { color: var(--content-sub-primary); }
.lockedPage { display: flex; flex-direction: column; align-items: center; gap: var(--space-2); padding: var(--space-6, 24px) var(--space-4);
  border-radius: 16px; background: color-mix(in srgb, var(--surface) 82%, transparent); text-align: center; font-weight: 700; }
.lockedPageText { font-size: var(--fs-subheadline); }
.topTabOn { background: var(--accent); color: var(--on-accent); font-weight: 700; }
.topTabDot { width: 8px; height: 8px; border-radius: 50%; background: var(--live); }
.topTabCount { min-width: 18px; height: 18px; padding: 0 5px; border-radius: 9px; background: var(--live); color: #fff; font-size: 11px; line-height: 18px; text-align: center; }

/* Этап 3а: «Рейтинг мира» — ступени дивизиона, зоны (битва фанатов снята §306) */
.tiers { display: flex; align-items: flex-end; gap: var(--space-2); overflow-x: auto; scrollbar-width: none; padding-bottom: 2px; }
.tiers::-webkit-scrollbar { display: none; }
.tier { flex: 1 0 64px; display: flex; flex-direction: column; align-items: center; gap: 4px; padding: var(--space-2) var(--space-1);
  border-radius: var(--radius-button); opacity: 0.55; }
.tierOn { opacity: 1; background: color-mix(in srgb, var(--accent) 18%, var(--ground)); }
.tierTitle { font-size: var(--fs-caption); font-weight: 600; text-align: center; }
.zones { display: flex; flex-wrap: wrap; gap: var(--space-3); margin-top: var(--space-2); font-size: var(--fs-caption); font-weight: 600; }
.zoneUp { color: var(--positive); }
.zoneDown { color: var(--live-ink); }
.hintLine { margin: var(--space-2) 0; }
/* строка-ссылка (комнаты чата болельщиков): во всю ширину, текст от левого края */
.linkRow { width: 100%; text-align: start; color: inherit; }
/* зоны группы: лёгкая заливка строки (своя строка — жёлтая поверх) */
.zone_promote { background: color-mix(in srgb, var(--positive) 12%, transparent); }
.zone_relegate { background: color-mix(in srgb, var(--live) 10%, transparent); }
.zone_promote + .zone_promote, .zone_relegate + .zone_relegate { margin-top: 2px; }
.lastResult { margin-top: var(--space-3); padding: var(--space-2) var(--space-3); border-radius: var(--radius-button); background: var(--ground);
  font-size: var(--fs-footnote); font-weight: 600; }
.out_promoted { background: color-mix(in srgb, var(--positive) 18%, var(--ground)); }
.out_relegated { background: var(--live-bg); }
.fanRow { display: flex; align-items: center; gap: var(--space-3); min-height: 48px; padding: 0 var(--space-2); border-radius: 10px; }
/* HQ-2072: длинное имя клуба или страны — одной строкой с «…», флаг рядом не сжимается */
.fanRow .rowTitle { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.meRowSep { margin-top: var(--space-2); padding-top: var(--space-2); border-top: 1px dashed var(--content-border); }
.secondary { width: 100%; min-height: 44px; border-radius: var(--radius-button); background: var(--ground); font-size: var(--fs-subheadline); font-weight: 600; }
.embed { margin: 0 calc(-1 * var(--space-4)); }
/* выбор «моей команды» (битва фанатов снята §306) */
.teamChoices { display: flex; flex-wrap: wrap; gap: 8px; margin-top: var(--space-2); }
.teamChoice { display: inline-flex; align-items: center; gap: 8px; padding: 6px 12px 6px 6px; border-radius: 20px;
  background: var(--ground); color: var(--content-primary); }
.teamChoiceName { font-size: var(--fs-subheadline); line-height: 1.334; font-weight: 500; }

/* Этап 3б: гильдии */
.roleChip { flex: none; padding: 2px 8px; border-radius: 10px; background: var(--ground); font-size: var(--fs-caption2); font-weight: 600; }
.role_chief { background: color-mix(in srgb, var(--accent) 40%, transparent); }
.role_helper { background: color-mix(in srgb, var(--purple) 30%, transparent); }
.onPage { background: var(--surface); }
.rowButton { align-items: flex-start; text-align: left; }

/* §306: место клуба на неделе — плитки одним рядом (--tiles — сколько их), на узком экране по две */
.tiles { display: grid; grid-template-columns: repeat(var(--tiles, 3), minmax(0, 1fr)); gap: var(--space-2); margin-bottom: var(--space-2); }
@media (max-width: 359px) { .tiles { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
.tile { display: flex; flex-direction: column; align-items: center; gap: 2px; padding: var(--space-2); border-radius: var(--radius-button);
  background: color-mix(in srgb, var(--ground) 70%, transparent); text-align: center; }
.tileValue { font-size: 22px; font-weight: 900; color: var(--accent-ink); }

/* §285 «Неделя»: строка срока под заголовком, шапка гильдии — кнопка к экрану гильдий */
.weekLine { margin: 0 var(--space-4) var(--space-2); }
.weekGuild { width: 100%; text-align: left; color: inherit; }
.weekGuild:active { transform: scale(0.99); }
.weekChevron { flex: none; font-size: 28px; line-height: 1; color: var(--content-secondary); }
.weekBtn { align-self: flex-start; margin-top: var(--space-2); }
/* §298: наборы за очки заданий */
.taskSets { display: flex; gap: 6px; flex-wrap: wrap; }
.taskSet { flex: 1 1 52px; min-height: 48px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1px; border-radius: 12px;
  background: var(--ground); font-weight: 800; font-size: var(--fs-subheadline); opacity: 0.7; }
.taskSetGems { font-size: 12px; display: inline-flex; align-items: center; gap: 2px; }
.set_ready { opacity: 1; background: linear-gradient(180deg, #8e6bff, #5b3fd6); color: #fff; box-shadow: inset 0 -3px 0 rgba(0, 0, 0, 0.2); }
.set_claimed { opacity: 0.55; }
/* §301: выбранный вид рейтинга клубов */
.scopeOn { background: var(--accent); color: var(--on-accent); }
/* HQ-190: «Сменить набор за просмотр» под кнопкой сброса за самоцветы */
.adPlace { align-self: flex-start; margin-top: var(--space-1, 4px); }
/* HQ-2344: строка клуба или страны — кнопка к странице клуба / игрокам страны */
.tapRow { width: 100%; text-align: left; }
.tapRow:active { transform: scale(0.99); }
